/* ppz-reveal.js — un pulsante che APRE, nella stessa pagina, una sezione chiusa.
 *
 * Nato il 05/10/2026 per le landing: chi ha gia' il diffusore e vuole solo le
 * ricariche non deve cambiare pagina (lui: «compare subito sotto la sezione con
 * le foto e le varianti»). Il riquadro «Hai gia' il diffusore?» (ppz-pdp-refills)
 * apre la seconda offerta (ppz-adv-offer segnata «Chiusa»).
 *
 * Contratto:
 *   [data-ppz-reveal="ID"]       il pulsante. E' un collegamento vero alla pagina
 *                                del prodotto: se questo file non parte, o la
 *                                sezione non c'e', porta li'.
 *   #ID[data-ppz-reveal-panel]   la sezione, stampata con `hidden`.
 *
 * Una volta aperta resta aperta: un secondo clic ci riporta soltanto sopra.
 * Lo scorrimento e' un semplice scrollIntoView: funziona chiunque scorra
 * (.page-wrapper da computer, la finestra da telefono), e a questo punto della
 * pagina le foto sopra sono gia' caricate, quindi il bersaglio non si sposta.
 */
(function () {
  if (window.ppzReveal) return;
  window.ppzReveal = true;

  function apri(el, morbido) {
    el.hidden = false;
    document.querySelectorAll('[data-ppz-reveal="' + el.id + '"]').forEach(function (a) {
      a.setAttribute('aria-expanded', 'true');
    });
    el.scrollIntoView({ behavior: morbido ? 'smooth' : 'auto', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-ppz-reveal]') : null;
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-ppz-reveal'));
    if (!el || !el.hasAttribute('data-ppz-reveal-panel')) return;
    e.preventDefault();
    apri(el, true);
  });

  /* Un indirizzo che finisce con #ID (da un'email, da un annuncio) trova la
     sezione gia' aperta. */
  function daIndirizzo() {
    var id = (window.location.hash || '').slice(1);
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.hasAttribute('data-ppz-reveal-panel') && el.hidden) apri(el, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', daIndirizzo);
  } else {
    daIndirizzo();
  }
})();
